
import React, { useState } from 'react';
import { Box, Paper, Chip } from '@mui/material';
// import FilterAlt from '@mui/icons-material/FilterAlt';

// import Sankey from './Sankey';
import AreaChart from './AreaChart';
// import Timeline from './TimelineChart';
import DockChart from './DockChart';
// import CameraChart from './CameraChart';

const innerCard = {
  width: '100%',
  height: '400px',
  position: 'relative',
  borderRadius: '12px',
  background: 'transparent'
};

// one styled chip for the 3-mode selector
const ModeChip = ({ active, label, onClick }) => (
  <Chip
    label={label}
    onClick={onClick}
    size="small"
    sx={{
      height: 30,
      borderRadius: '999px',
      px: 1.5,
      fontSize: 12.5,
      color: '#FFFFFF !important',
      background: active ? 'rgba(54,197,240,0.18)' : 'transparent',
      border: active ? '1px solid #36C5F0' : '1px solid rgba(255,255,255,0.26)',
      boxShadow: active ? 'inset 0 0 0 1px rgba(54,197,240,0.25)' : 'none',
      '& .MuiChip-label': {
        color: '#FFFFFF !important'
      },
      '&:hover': {
        background: active ? 'rgba(54,197,240,0.24)' : 'rgba(255,255,255,0.06)',
        borderColor: active ? '#36C5F0' : 'rgba(255,255,255,0.38)',
        '& .MuiChip-label': {
          color: '#FFFFFF !important'
        }
      }
    }}
  />
);

export default function TrendsChart() {
  const [chartValue, setChartValue] = useState('Detections');
  // const [anchorEl, setAnchorEl] = useState(null);
  // const [selectedZone, setSelectedZone] = useState('all');
  // const [zoneOptions] = useState([
  //   { zone_id: 1, name: 'zone-a' },
  //   { zone_id: 2, name: 'zone-b' }
  // ]);

  const modes = ['Detections', 'Dock Utilizations', 'Camera'];

  return (
    <Box>
      {/* top row: left = legend placeholder (optional), right = mode chips + filter */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pb: 1
        }}
      >
        {/* Left: legend (optional – hide or replace with your series legend) */}
        <Box sx={{ display: 'flex', gap: 1.25, alignItems: 'center' }}>
          {/* Example mini-legend like screenshot; remove if your chart renders its own */}
          {/* <LegendPill color="#FFC107" label="human" />
          <LegendPill color="#44BE54" label="truck" />
          <LegendPill color="#B367FF" label="HIE" />
          <LegendPill color="#36C5F0" label="shutter_open" />
          <LegendPill color="#8EA0B5" label="shutter_close" /> */}
        </Box>

        {/* Right: mode chips + filter */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
          {modes.map((m) => (
            <ModeChip key={m} label={m} active={chartValue === m} onClick={() => setChartValue(m)} />
          ))}

          {/* Filter icon (styled like screenshot) */}
        </Box>
      </Box>

      {/* Chart container */}
      <Paper elevation={0} sx={innerCard}>
        {chartValue === 'Dock Utilizations' ? (
          <DockChart />
        ) : /* chartValue === 'Camera' ? (
          <CameraChart />
        ) : */ (
          <AreaChart />
        )}
      </Paper>
    </Box>
  );
}
